// .../shared/production/refiner-production-inline-messages.ts

import { localeNumberWithFixed } from 'psims/lib/formatters/numbers';
import { ValidationResult } from './refiner-production-validation';

export function getInlineMessage(validationResult: ValidationResult | null) {
  if (validationResult == null) return undefined;

  switch (validationResult.code) {
    case 'invalid_required':
      return 'A value is required for this field';
    case 'invalid_integer':
    case 'invalid_integer_range':
      return `Must be a positive integer (zero is permitted) with a maximum value of ${localeNumberWithFixed(validationResult.max)}`;
  }
}